@if (isHideSidebarHeader) {
  <app-header></app-header>
}
@if (isHideSidebarHeader) {
  <app-sidebar></app-sidebar>
}
@if (isHideSidebarHeader) {
  <app-right-sidebar></app-right-sidebar>
}
<div [dir]="direction">
  <app-spinner></app-spinner>

  <router-outlet></router-outlet>
</div>
